//LOAD SCRIPTS (RECAPTCHA ETC) ONLY WHEN THE USER IS ON THE FORM
//TO IMPROVE CORE WEB VITALS
// the IntersectionObserver is a js native function that exploits the "observable pattern"
// and gives us an event when an html element enters the users's viewport.
const initFormsExternalScripts = () => {
    // instance new observer (event emitter)
    const observer = new IntersectionObserver((entries) => {
        //function that triggers once the event is observed
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initIubendaProof();
                initRecaptcha();
            }
        });
    });
    //observe (event subscriber / obsever)
    contactForms.forEach((element) => {
        observer.observe(element);
    });
};
